import React from 'react';
import styled from 'styled-components';
import { UserVote } from './VoteStorage';
import { HeroBackdrop, HeroImage, HeroVideo, Overlay, BottomGradient, BottomHUD, TitleTop, VoteButtonsContainer, CircleButton } from '../ScrollVote/ScrollVote.styles';

interface VoteDetailModalProps {
  vote: UserVote | null;
  isOpen: boolean;
  onClose: () => void;
  onSubmitVote?: () => void;
  onAddDraft?: () => void;
}

const ModalOverlay = styled.div<{ isOpen: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: ${props => props.isOpen ? 'flex' : 'none'};
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(5px);
  

  // @media (min-width: 1025px) {
  //   align-items: flex-start; // start at top
  //   padding: 4vh 0; // breathing room top/bottom on desktop
  // }
`;

const ModalContent = styled.div`
  // background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  background: black;

  border-radius: 1rem;
  max-width: 1200px;
  width: 50%;
  max-height: 95vh;
  height: 60vh;
  overflow-y: auto;
  position: relative;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);
  padding-bottom: 90px;
    
  @media (max-width: 1024px) {
    width: 60%;
    height: 60vh;
  }
  
  @media (max-width: 768px) {
    width: 95%;
    height: 65vh;    
  }
  
  @media (max-width: 480px) {
    width: 95%;
    height: 65vh;
  }
`;



const FloatingActions = styled.div`
  width:${window.screen.width > 768 ? "30%" : "95%"};
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  bottom: 100px;
  display: flex;
  gap: 0.75rem;
  z-index: 1001;
  pointer-events: auto;
  bottom:14%;

  @media (max-width: 1024px) {
    display: none;
  }
`;

const MobileActions = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: clamp(12px, 4vh, 24px);
  display: flex;
  justify-content: center;
  gap: 0.75rem;
  padding: 0 16px;
  z-index: 10;
  pointer-events: auto;
  bottom:10%;
  @media (min-width: 1025px) {
    display: none;
  }
`;


const CloseButton = styled.button`
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 1.5rem;
  z-index: 10;
  transition: background-color 0.2s;
  
  &:hover {
    background: rgba(0, 0, 0, 0.7);
  }
`;

const MediaSection = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 1rem;
  overflow: hidden;
  z-index: 1;
`;

const MediaImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const MediaVideo = styled.video`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const DefaultBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  // background: 
  //   radial-gradient(circle at 20% 50%, rgba(120, 119, 198, 0.3) 0%, transparent 50%),
  //   radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),
  //   radial-gradient(circle at 40% 80%, rgba(120, 119, 198, 0.2) 0%, transparent 50%),
  //   linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  filter: blur(1px);
  z-index: 1;
`;

const MediaOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.5));
  z-index: 2;
`;

const ContentSection = styled.div`
  position: relative;
  z-index: 3;
  padding: 2rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  
  @media (max-width: 768px) {
    padding: 1.5rem;
  }
  
  @media (max-width: 480px) {
    padding: 1rem;
  }
`;

const TopSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  justify-content: center;
`;

const BottomSection = styled.div`
  margin-top: auto;
  padding-top: 2rem;
`;

const ActionsBar = styled.div`
  display: flex;
  gap: 0.75rem;
  margin-top: 0.75rem;
`;

const ActionButton = styled.button<{ $bg?: string }>`
  flex: 1;
  background-color: ${(p) => p.$bg || '#6352e8'};
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 0.375rem;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover { filter: brightness(1.05); }
`;

const VoteTitle = styled.h2`
  font-size: 2rem;
  font-weight: 700;
  color: white;
  margin: 0 0 1.5rem 0;
  line-height: 1.3;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  text-align: center;
  
  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
  
  @media (max-width: 480px) {
    font-size: 1.25rem;
  }
`;

const OptionsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 5rem;
  align-items: center;

`;

const OptionCard = styled.div<{ isSelected?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  
`;

const OptionIcon = styled.div`
  font-size: 2.5rem;
  margin-bottom: 0.5rem;
  padding-top:10px;
  border: 3px solid #ffffff;
  border-radius: 50%;
  width: 70px;
  height: 70px;
  text-align: center;
  background: rgba(255, 255, 255, 0.25);
  backdrop-filter: blur(15px);
  transition: all 0.3s ease;
  cursor: pointer;
  justify-content: center;
  color:white;
  
  img {
    width: 2.5rem;
    height: 2.5rem;
    object-fit: cover;
    border-radius: 50%;
  }
  
  @media (max-width: 768px) {
    font-size: 2rem;
    
    img {
      width: 2rem;
      height: 2rem;
    }
  }
  
  @media (max-width: 480px) {
    font-size: 1.75rem;
    margin-bottom: 0.25rem;
    
    img {
      width: 1.75rem;
      height: 1.75rem;
    }
  }
`;

const OptionText = styled.div`
  font-size: 0.875rem;
  font-weight: 600;
  color: white;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  line-height: 1.2;
  
  @media (max-width: 768px) {
    font-size: 0.75rem;
  }
  
  @media (max-width: 480px) {
    font-size: 0.7rem;
  }
`;

const VoteChoice = styled.div`
  background: rgba(255, 255, 255, 0.1);
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 0.75rem;
  padding: 1rem;
  margin-bottom: 1.5rem;
  text-align: center;
  backdrop-filter: blur(10px);
`;

const ChoiceLabel = styled.div`
  font-size: 0.875rem;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 500;
  margin-bottom: 0.25rem;
`;

const ChoiceValue = styled.div`
  font-size: 1.125rem;
  font-weight: 700;
  color: white;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
`;

const getFileIcon = (fileType?: string): string => {
  if (!fileType) return '📄';
  if (fileType.startsWith('image/')) return '🖼️';
  if (fileType.startsWith('video/')) return '🎥';
  if (fileType.startsWith('audio/')) return '🎵';
  if (fileType.includes('pdf')) return '📄';
  if (fileType.includes('doc')) return '📝';
  return '📎';
};

const formatDate = (timestamp: number): string => {
  return new Date(timestamp).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

const VoteDetailModal: React.FC<VoteDetailModalProps> = ({ vote, isOpen, onClose, onSubmitVote, onAddDraft }) => {
  if (!vote) return null;

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };




  return (
    <ModalOverlay isOpen={isOpen} onClick={handleOverlayClick}>
      <ModalContent>
        <CloseButton onClick={onClose}>×</CloseButton>
        <MediaSection>
          {vote.imageUrl && vote?.fileType?.startsWith('image') ? (
            <>
              <HeroBackdrop src={vote.imageUrl} alt="" aria-hidden />
              <HeroImage
                src={vote.imageUrl}
                alt={vote.title}
              />
            </>
          ) : vote?.videoUrl ? (
            <HeroVideo
              src={vote.videoUrl}
              // muted
              autoPlay
              playsInline
              preload="metadata"
            />
          ) : (
            <DefaultBackground />
          )}
        </MediaSection>

        <Overlay>
          <BottomGradient />
          <TitleTop style={{ bottom: "100px" }}>{vote.title}</TitleTop>
          <BottomHUD style={{ bottom: "20px" }}>
            <VoteButtonsContainer style={{
              marginBottom: "0px"
            }}>
              <CircleButton disabled>{vote.option1}</CircleButton>
              <CircleButton disabled>{vote.option2}</CircleButton>
            </VoteButtonsContainer>
          </BottomHUD>
        </Overlay>
      </ModalContent>
      {(onSubmitVote || onAddDraft) && <MobileActions>
        <ActionButton $bg="#6352e8" onClick={onSubmitVote} disabled={!onSubmitVote}>Submit Vote</ActionButton>
        <ActionButton $bg="#9a90e7" onClick={onAddDraft} disabled={!onAddDraft}>Add In Draft</ActionButton>
      </MobileActions>}

      {/* Desktop fixed footer actions */}
      {(onSubmitVote || onAddDraft) && <FloatingActions>
        <ActionButton $bg="#6352e8" onClick={onSubmitVote} disabled={!onSubmitVote}>Submit Vote</ActionButton>
        <ActionButton $bg="#9a90e7" onClick={onAddDraft} disabled={!onAddDraft}>Add In Draft</ActionButton>
      </FloatingActions>}
    </ModalOverlay>
  );
};

export default VoteDetailModal;